var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 432C32 458.51 53.49 480 80 480H432C458.51 480 480 458.51 480 432V160H32V432ZM160 236C160 229.406 165.406 224 172 224H340C346.594 224 352 229.406 352 236V244C352 250.594 346.594 256 340 256H172C165.406 256 160 250.594 160 244V236ZM480 32H32C14.312 32 0 46.312 0 64V112C0 120.812 7.188 128 16 128H496C504.812 128 512 120.812 512 112V64C512 46.312 497.688 32 480 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArchive);
export default __webpack_public_path__ + "static/media/box-archive.6841c6871bbf8043675c2fb4d9b30a0a.svg";
export { ForwardRef as ReactComponent };